<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${supplier.company_name}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="supplier" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "supplier-view-logs",

  components: { LogListTable },

  props: ["supplier"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
